import styled from "styled-components";

export const ConfirmForm = styled.form`
    margin-top: 16px;
`